import * as yup from "yup";

export const forgotPasswordSchema = yup.object().shape({
    email: yup.string().email("Please enter a valid Email address").required("Field is required"),
});
